import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useLang } from "@/i18n";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export default function PaymentSuccessPage() {
  const { t } = useLang();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState("checking");
  const attempts = useRef(0);

  useEffect(() => {
    if (!sessionId) { setState("failed"); return; }
    let timer;
    const poll = async () => {
      try {
        const r = await api.get(`/payments/status/${sessionId}`);
        if (r.data.payment_status === "paid") { setState("paid"); return; }
      } catch {}
      attempts.current += 1;
      if (attempts.current >= 15) { setState("failed"); return; }
      timer = setTimeout(poll, 2000);
    };
    poll();
    return () => clearTimeout(timer);
  }, [sessionId]);

  return (
    <div className="max-w-md mx-auto pt-16 md:pl-14" data-testid="payment-success-page">
      <div className="bg-card border rounded-2xl p-8 text-center space-y-4 animate-fade-up">
        {state === "checking" && (
          <>
            <Loader2 className="h-14 w-14 animate-spin text-primary mx-auto" />
            <h1 className="font-display text-xl font-extrabold">{t("pay.checking")}</h1>
          </>
        )}
        {state === "paid" && (
          <>
            <CheckCircle2 data-testid="payment-success-icon" className="h-14 w-14 text-emerald-600 mx-auto" />
            <h1 className="font-display text-2xl font-extrabold">{t("pay.successTitle")}</h1>
            <p className="text-sm text-muted-foreground">{t("pay.successBody")}</p>
            <Button data-testid="payment-success-dashboard" onClick={() => navigate("/dashboard")}
              className="w-full h-12 tactile-btn font-bold">{t("pay.backDashboard")}</Button>
          </>
        )}
        {state === "failed" && (
          <>
            <XCircle className="h-14 w-14 text-red-600 mx-auto" />
            <h1 className="font-display text-2xl font-extrabold">{t("pay.failedTitle")}</h1>
            <Button data-testid="payment-failed-plans" variant="outline" onClick={() => navigate("/prezzi")}
              className="w-full h-12 tactile-btn">{t("pay.backPlans")}</Button>
          </>
        )}
      </div>
    </div>
  );
}
